// src/components/timetable/parts/TimetableTypeChips.tsx
import React from 'react';

interface TimetableType {
  id: string;
  label: string;
}

interface Props {
  timetableTypes: TimetableType[];
  selectedTimetableTypeId: string;
  onSelect: (id: string) => void;
}

const TimetableTypeChips: React.FC<Props> = ({
  timetableTypes,
  selectedTimetableTypeId,
  onSelect,
}) => {
  return (
    <>
      <style>{`
        .chip-button {
          padding: 6px 14px;
          border: 1.5px solid #e5e7eb;
          border-radius: 8px;
          background: white;
          color: #1f2937;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          outline: none;
          transition: all 0.2s ease;
        }
        .chip-button.selected {
          border-color: #3b82f6;
          background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%);
          color: white;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
        }
        .chip-button:hover:not(.selected) {
          background: #f0f9ff;
          transform: translateY(-1px);
        }
      `}</style>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {timetableTypes.length === 0 ? (
          <div style={{ padding: '6px 14px', color: '#64748b', fontSize: '13px', fontWeight: '500' }}>
            No timetable types available
          </div>
        ) : (
          timetableTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => onSelect(type.id)}
              className={`chip-button ${selectedTimetableTypeId === type.id ? 'selected' : ''}`}
            >
              {type.label}
            </button>
          ))
        )}
      </div>
    </>
  );
};

export default TimetableTypeChips;